import React, { Component } from 'react';
import Grid from '@material-ui/core/Grid';
import _sortBy from 'lodash/sortBy';
import TextField from '../../../common/TextField';
import Select from '../../../common/Select';
import _get from 'lodash/get';
import { getTextFromLanguage } from '../../../../helper/languageHelper';
const uuidv4 = require('uuid/v4');

const CollectionSlug = ({
  classes,
  collection,
  collectionId,
  updateCollection,
  languages
}) => {
  const slugId =
    collection.slugs && collection.slugs.id ? collection.slugs.id : uuidv4();
  return (
    <Grid container>
      {languages.map((language, index) => {
        var slugText = '';
        try {
          slugText = getTextFromLanguage(collection.slugs, language);
        } catch (error) {}
        return (
          <Grid
            container
            key={'style-slugText-' + index}
            direction="row"
            alignItems="flex-end"
            spacing={1}
            className={classes.container}
          >
            <Grid item xs={10}>
              <TextField
                dataCy={'Collection-Slug-' + language}
                label="Slug/URL"
                placeholder="Enter slug"
                rowsMax="4"
                value={slugText}
                onChange={e => {
                  updateCollection({
                    optimisticResponse: {
                      __typename: 'Mutation',
                      updateCollection: {
                        ...collection,
                        slugs: languages.map((tempSlug, index) => {
                          return {
                            langCode: tempSlug,
                            content:
                              tempSlug === language
                                ? e.target.value
                                : getTextFromLanguage(
                                    collection.slugs,
                                    tempSlug
                                  ),
                            __typename: 'SlugLocalised'
                          };
                        })
                      }
                    },
                    variables: {
                      id: collectionId,
                      input: {
                        slugs: languages.map((tempSlug, index) => {
                          return {
                            langCode: tempSlug,
                            content:
                              tempSlug === language
                                ? e.target.value
                                : getTextFromLanguage(
                                    collection.slugs,
                                    tempSlug
                                  )
                          };
                        })
                      }
                    }
                  });
                }}
              />
            </Grid>
            <Grid item xs={2}>
              <Grid
                container
                alignItems="center"
                justify="center"
                style={{
                  height: 38,
                  width: '100%',
                  border: '1px solid #ddd',
                  borderRadius: '3px'
                }}
              >
                {language}
              </Grid>
            </Grid>
          </Grid>
        );
      })}
    </Grid>
  );
};

export default CollectionSlug;
